import Backbone from 'backbone'
import template from './new-column-name-chooser.hbs'
import ScrollingDialogTable from 'scoreboard/components/scrolling-dialog-table'
import _ from 'lodash'
import $ from 'jquery'
import formHelper from 'scoreboard/components/form-helper'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'
import FormView from 'scoreboard/components/form-view'
import Dataset from 'scoreboard/datasets/model/dataset'

const NewColumnNameChooser = Backbone.View.extend({
	tagName: 'form',

	initialize: function(options = {}) {
		this.options = options

		const MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true,
			guard: false
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		this.options.wizard.render({
			el: this.el,
			formView: this.formView,
			doneKey: 'admin.import'
		})

		this.renderSelects()

		this.scrollingDialogTable = new ScrollingDialogTable({
			el: this.$('.panel-content'),
			siblings: [this.$('.banner')],
			staticElementsHeight: 300
		}).render()

		this.formView.start()
		return this
	},

	renderSelects: function() {
		const availableColumns = this.options.mappingData.available

		let options = _.map(availableColumns, option =>
			({ label: option, value: option, group: i18n.get('admin.import.unused') }))
		_.each(this.$('select.new-name'), select =>
			selects.filtering(select, {
				options: _.cloneDeep(options),
				groupBy: 'group'
			})
		)

		if (availableColumns.length === 1) {
			// #37144 if there is only 1 column to map, we can just go ahead and
			// populate it
			formHelper.writeToDom({ 'select-0': availableColumns[0] }, this.el)
		}
	},

	context: function() {
		let data = []
		_.forEach(this.options.mappingData.missing, (element, index) => {
			data[index] = { id: index, original: element }
		})
		return {
			destinationItems: data
		}
	},

	getColumnMap: function() {
		let columnMap = {}
		_.each(this.$('select.new-name'), (el) => {
			let selectId = $(el).data('id')
			columnMap[this.options.mappingData.missing[selectId]] = el.value
		})

		return columnMap
	},

	// #37829 ensure that users can't select the same column for multiple different
	// fields
	test: function() {
		const columnMap = this.getColumnMap()
		const selectedValues = _.values(columnMap)
		if (_.some(selectedValues, s => !s)) {
			return i18n.get('datasets.missingColumns.allColumnsRequired')
		}
		if (_.uniq(selectedValues).length !== selectedValues.length) {
			return i18n.get('datasets.missingColumns.noDuplicateMappings')
		}
	},

	submit: function() {
		// Obtain the column mappings
		const columnMap = this.getColumnMap()

		if (!_.isNil(this.options.replaceAllRecords)) {
			this.model.set('replaceAllRecords', this.options.replaceAllRecords)
		}

		if (this.options.submitHandler) {
			// #36911 in the case of the worksheet-options dialog, we need to simply
			// provide the user chosen mappings and let the save continue as normal
			this.options.submitHandler(columnMap)
		} else if (this.options.wizard && this.options.wizard.submitHandler) {
			this.options.wizard.submitHandler(columnMap)
		} else {
			const url = this.options.url
			const params = _.clone(this.options.params || {})
			params.fileId = this.options.fileId
			return $.post({
				url: `${url}?${$.param(params)}`,
				data: JSON.stringify(columnMap),
				success: dataset => {
					this.model = new Dataset(dataset)
					if (this.options.successHandler) {
						this.options.successHandler(this.model)
					} else {
						if (this.options.wizard.isLastStep()) {
							// uploading new spreadsheet; we are done
							this.options.wizard.finish(this.model)
							this.trigger('done', this.model)
						} else {
							// editing the data source; move on to preview
							this.model.set('newColumnNames', columnMap)
							this.options.wizard.next()
						}
					}
				},
				error: (xhr) => {
					this.formView.error(xhr)
				}
			})
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		// #13853 if a spreadsheet is uploading, abort the upload

		_.invokeMap([this.formView, this.scrollingDialogTable], 'remove')
	}
})

export default NewColumnNameChooser
NewColumnNameChooser.__filename__ = 'imports/new-column-name-chooser.js'
